/**
 * Block „Mehr lesen" (blocks/read-more): Klick auf den Link klappt den Inhalt weich auf
 * (Grid-Zeile 0fr → 1fr per CSS) und blendet den Link aus. Einmalig, kein Zuklappen.
 *
 * Ohne JavaScript fehlt dem <html> die Klasse „js" (gesetzt in inc/functions-enqueue.php),
 * dann ist der Inhalt von Anfang an sichtbar und der Link ausgeblendet.
 */
(function () {
    document.addEventListener("click", function (e) {
        var toggle = e.target.closest(".read-more__toggle");
        if (!toggle) return;

        var block = toggle.closest(".read-more");
        if (!block || block.classList.contains("is-open")) return;

        block.classList.add("is-open");
        toggle.setAttribute("aria-expanded", "true");

        // Nach dem Aufklappen den Link ganz aus dem Fluss nehmen (Platz, Tab-Reihenfolge).
        var duration = parseFloat(getComputedStyle(block).getPropertyValue("--read-more-speed")) || 0.4;
        window.setTimeout(function () {
            toggle.hidden = true;
        }, duration * 1000);

        // Fokus zum aufgeklappten Inhalt, damit Tastatur-/Screenreader-Nutzer dort weiterlesen.
        var content = block.querySelector(".read-more__content");
        if (content) {
            content.setAttribute("tabindex", "-1");
            content.focus({ preventScroll: true });
        }
    });
})();
